<template>
  <div style="height: calc(100% - 20px); display: flex; flex-direction: column; align-items: center">
    <div
      style="height: 40px; width: 95%; margin: 10px; border-bottom: 1px #d0d0d0 solid; display: flex;">
      <div v-if="!(dataType===7)">
        <el-date-picker
          v-model="timeDate"
          type="date"
          placeholder="选择日期">
        </el-date-picker>
      </div>
      <div style="margin-left: 20px" v-if="dataType!==7">
        <el-select v-model="posSelectValue" placeholder="请选择">
          <el-option
            v-for="item in posSelectOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div style="margin-left: 20px" v-if="dataType === 3 || dataType === 4">
        <el-select v-model="rSelectValue" placeholder="请选择">
          <el-option
            v-for="item in rSelectOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
    </div>
    <div style="width: 90%; height: 50%" :style="dataType===7?'height: 90%': ''">
      <el-table
        :data="tableData"
        stripe
        height="100%"
        style="width: 100%;">
        <el-table-column
          v-if="tableTitle[0]"
          prop="dt"
          :label="tableTitle[0]">
        </el-table-column>
        <el-table-column
          v-if="tableTitle[1]"
          prop="a"
          :label="tableTitle[1]">
        </el-table-column>
        <el-table-column
          v-if="tableTitle[2]"
          prop="b"
          :label="tableTitle[2]">
        </el-table-column>
        <el-table-column
          v-if="tableTitle[3]"
          prop="c"
          :label="tableTitle[3]">
        </el-table-column>
        <el-table-column
          v-if="tableTitle[4]"
          prop="t"
          :label="tableTitle[4]">
        </el-table-column>
      </el-table>
    </div>
    <div style="width: calc(90% - 20px); height: calc(50% - 80px); background: white; margin-top: 10px; padding: 10px"
         v-show="dataType!==7">
      <div id="main" style="height: 100%; width: 100%"></div>
    </div>
    <el-dialog title="电能质量事件波形记录" :visible.sync="dialogTableVisible" v-show="dialogTableVisibleShow">
      <div id="eventWaveChart" style="height: 50vh; width: 50vw"></div>
    </el-dialog>
  </div>
</template>

<script>
import {formatTime} from '@/utils/index'

export default {
  name: 'History',
  data () {
    return {
      options: {
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          x: 80,
          y: 30,
          y2: 25
          // x2: 120
        },
        toolbox: {},
        legend: {},
        xAxis: [
          {
            type: 'category',
            data: []
          }
        ],
        yAxis: [],
        series: []
      },
      chart: null,
      timeDate: '',
      // 表格配置
      tableTitle: [],
      // tableName: [],
      tableData: [],
      // 下拉
      posSelectValue: 1,
      posSelectOptions: [{
        value: 0,
        label: ''
      }],
      rSelectValue: 1,
      rSelectOptions: [{
        value: 0,
        label: ''
      }],
      historyData: [],
      interval: null,
      commandInterval: null,
      lastTs: 0,
      // 电能质量事件波形弹窗
      dialogTableVisible: true,
      dialogTableVisibleShow: false,
      dialogEventWaveChart: null,
      dialogEventWaveOption: {
        legend: {
          data: ['Ua', 'Ub', 'Uc'],
          // right: 30,
          top: 20,
          formatter: ''
        },
        grid: {
          y2: 40
        },
        toolbox: {
          show: true,
          feature: {}
        },
        calculable: true,
        xAxis: [{
          type: 'category',
          name: 'ms',
          data: [1, 2],
          axisLabel: {
            show: true,
            interval: 0
          },
          axisTick: {
            show: false
          }
        }],
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value} V'
          }
        }],
        series: [{
          name: 'Ua',
          type: 'line',
          showSymbol: false,
          itemStyle: {
            color: '#fccc00'
          },
          data: [1, 2]
        }, {
          name: 'Ub',
          type: 'line',
          showSymbol: false,
          itemStyle: {
            color: '#009800'
          },
          data: [1, 2]
        }, {
          name: 'Uc',
          type: 'line',
          showSymbol: false,
          itemStyle: {
            color: '#ff0000'
          },
          data: [1, 2]
        }
        ]
      }
    }
  },
  watch: {
    dataType (page) {
      this.posSelectValue = 1
      this.setShowVal(page)
    },
    posSelectValue () {
      this.setShowVal(this.dataType)
    },
    rSelectValue () {
      this.setShowVal(this.dataType)
    },
    timeDate () {
      this.setShowVal(this.dataType)
    },
    '$store.state.highSpdMode' () {
      this.setShowVal(this.dataType)
    },
    dialogTableVisible () {
      this.dialogTableVisibleShow = this.dialogTableVisible
    }
  },
  computed: {
    dataType () {
      return Number(this.$route.query.dataType)
    }
  },
  mounted () {
    this.timeDate = formatTime(new Date(), 'yyyy-MM-dd') // 页面加载时显示当前时间

    this.setShowVal(this.dataType)

    this.dialogTableVisible = false
  },
  destroyed () {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
    this.pollStop()

    this.$store.commit('updateSpeedMode', '普通模式')
  },
  methods: {
    pollCommand () {
      if (this.$store.state.reqMode === 'udp' || this.$store.state.highSpdMode) {
        this.sendCommand()
        if (!this.commandInterval) {
          this.commandInterval = setInterval(() => {
            this.sendCommand()
          }, 600000)
        }
      } else {
        this.pollStop()
      }
    },
    pollStop () {
      if (this.commandInterval) {
        clearInterval(this.commandInterval)
        this.commandInterval = null
        console.log('关')
      }
    },
    sendCommand () {
      this.$api.command({
        sn: this.$store.state.sn ? this.$store.state.sn : window.localStorage.getItem('sn'),
        lists: [[1, 6, 5]]
      }).then(res => {
        if (res.data.code !== 0) {
          this.$message.error(res.data.msg)
        }
      })
    },
    async setShowVal (page) {
      await this.setTable(page)
      await this.updateData(this.timeDate)
      await this.setData(page)
      if (this.interval) {
        clearInterval(this.interval)
        this.interval = null
      }
      this.pollStop()
    },

    setTable (page) {
      var tableTitle = []
      var posSelectOptions = []
      var rSelectOptions = []
      if (page === 1) {
        tableTitle = ['时间', 'A相', 'B相', 'C相', '总']
        posSelectOptions = [{
          value: 1,
          label: 'P'
        }, {
          value: 2,
          label: 'Q'
        }, {
          value: 3,
          label: 'S'
        }, {
          value: 4,
          label: 'QF'
        }, {
          value: 5,
          label: 'QH'
        }]
        // if (this.posSelectValue === 1) {
        //   this.tableName = ['p_pha', 'p_phb', 'p_phc', 'p_total']
        // } else if (this.posSelectValue === 2) {
        //   this.tableName = ['q_pha', 'q_phb', 'q_phc', 'q_total']
        // } else if (this.posSelectValue === 3) {
        //   this.tableName = ['s_pha', 's_phb', 's_phc', 's_total']
        // } else if (this.posSelectValue === 4) {
        //   this.tableName = ['qf_pha', 'qf_phb', 'qf_phc', 'qf_total']
        // } else if (this.posSelectValue === 5) {
        //   this.tableName = ['qh_pha', 'qh_phb', 'qh_phc', 'qh_total']
        // }
      } else if (page === 2) {
        tableTitle = ['时间', 'A相', 'B相', 'C相', 'AVE']
        posSelectOptions = [{
          value: 1,
          label: 'PF'
        }, {
          value: 2,
          label: 'DPF'
        }]
      } else if (page === 3 || page === 4) {
        posSelectOptions = [{
          value: 1,
          label: '相电压'
        }, {
          value: 2,
          label: '线电压'
        }, {
          value: 3,
          label: '电流'
        }]
        if (page === 3) {
          rSelectOptions = [{
            value: 1,
            label: '全波'
          }, {
            value: 2,
            label: '基波'
          }]
        } else {
          rSelectOptions = [{
            value: 1,
            label: 'THD-F'
          }, {
            value: 2,
            label: 'THD-R'
          }]
        }
        if (this.posSelectValue === 3) {
          tableTitle = ['时间', 'A相', 'B相', 'C相', '零相']
        } else {
          tableTitle = ['时间', 'A相', 'B相', 'C相']
        }
      } else if (page === 5) {
        posSelectOptions = [{
          value: 1,
          label: '相电压'
        }, {
          value: 2,
          label: '线电压'
        }, {
          value: 3,
          label: '电流'
        }]
        if (this.posSelectValue === 2) {
          tableTitle = ['时间', '正序分量', '负序分量', '不平衡度(%)']
        } else {
          tableTitle = ['时间', '正序分量', '负序分量', '零序分量', '不平衡度(%)']
        }
      } else if (page === 6) {
        posSelectOptions = [{
          value: 1,
          label: 'P'
        }, {
          value: 2,
          label: 'Q'
        }, {
          value: 3,
          label: 'S'
        }]
        tableTitle = ['时间', 'A相', 'B相', 'C相', '总']
      } else if (page === 7) {
        tableTitle = ['序号', '事件', '发生时刻', '持续时间(ms)', '查看波形']
      }

      this.tableTitle = tableTitle
      this.posSelectOptions = posSelectOptions
      this.rSelectOptions = rSelectOptions
    },

    setData (page) {
      var i = 0
      var max = 0
      var min = 0x7fff
      var chartData = {
        a: [],
        b: [],
        c: [],
        t: [],
        dt: []
      }
      var tableData = []
      var tableDataItem = {
        a: 0,
        b: 0,
        c: 0,
        t: 0,
        dt: ''
      }
      var option = [{
        name: 'A相',
        type: 'line',
        symbolSize: 0,
        data: [],
        itemStyle: {
          color: '#ffaa00'
        }
      }, {
        name: 'B相',
        type: 'line',
        symbolSize: 0,
        data: [],
        itemStyle: {
          color: '#00aa00'
        }
      }, {
        name: 'C相',
        type: 'line',
        symbolSize: 0,
        data: [],
        itemStyle: {
          color: '#ff0000'
        }
      }]
      var yAxis = [{
        type: 'value',
        axisLabel: {
          formatter: ''
        }
      }]

      if (page === 1) {
        if (this.posSelectValue === 1) {
          for (i = 0; i < this.historyData.length; i++) {
            if (max < this.historyData[i].p_pha) max = this.historyData[i].p_pha
            if (max < this.historyData[i].p_phb) max = this.historyData[i].p_phb
            if (max < this.historyData[i].p_phc) max = this.historyData[i].p_phc
            // if (max < this.historyData[i].p_total) max = this.historyData[i].p_total
            if (min > this.historyData[i].p_pha) min = this.historyData[i].p_pha
            if (min > this.historyData[i].p_phb) min = this.historyData[i].p_phb
            if (min > this.historyData[i].p_phc) min = this.historyData[i].p_phc
            // if (min > this.historyData[i].p_total) min = this.historyData[i].p_total
          }

          if (max > 1000 || min < -1000) {
            yAxis[0].axisLabel.formatter = '{value} MW'
            for (i = 0; i < this.historyData.length; i++) {
              chartData.a[i] = (this.historyData[i].p_pha / 1000).toFixed(2)
              chartData.b[i] = (this.historyData[i].p_phb / 1000).toFixed(2)
              chartData.c[i] = (this.historyData[i].p_phc / 1000).toFixed(2)
              chartData.t[i] = (this.historyData[i].p_total / 1000).toFixed(2)
              tableDataItem.a = (this.historyData[i].p_pha / 1000).toFixed(2) + 'MW'
              tableDataItem.b = (this.historyData[i].p_phb / 1000).toFixed(2) + 'MW'
              tableDataItem.c = (this.historyData[i].p_phc / 1000).toFixed(2) + 'MW'
              tableDataItem.t = (this.historyData[i].p_total / 1000).toFixed(2) + 'MW'
              tableData[i] = {...tableDataItem}
            }
          } else {
            yAxis[0].axisLabel.formatter = '{value} kW'
            for (i = 0; i < this.historyData.length; i++) {
              chartData.a[i] = this.historyData[i].p_pha.toFixed(2)
              chartData.b[i] = this.historyData[i].p_phb.toFixed(2)
              chartData.c[i] = this.historyData[i].p_phc.toFixed(2)
              chartData.t[i] = this.historyData[i].p_total.toFixed(2)
              tableDataItem.a = this.historyData[i].p_pha.toFixed(2) + 'kW'
              tableDataItem.b = this.historyData[i].p_phb.toFixed(2) + 'kW'
              tableDataItem.c = this.historyData[i].p_phc.toFixed(2) + 'kW'
              tableDataItem.t = this.historyData[i].p_total.toFixed(2) + 'kW'
              tableData[i] = {...tableDataItem}
            }
          }
        } else if (this.posSelectValue === 3) {
          for (i = 0; i < this.historyData.length; i++) {
            if (max < this.historyData[i].s_pha) max = this.historyData[i].s_pha
            if (max < this.historyData[i].s_phb) max = this.historyData[i].s_phb
            if (max < this.historyData[i].s_phc) max = this.historyData[i].s_phc
            // if (max < this.historyData[i].s_total) max = this.historyData[i].s_total
            if (min > this.historyData[i].s_pha) min = this.historyData[i].s_pha
            if (min > this.historyData[i].s_phb) min = this.historyData[i].s_phb
            if (min > this.historyData[i].s_phc) min = this.historyData[i].s_phc
            // if (min > this.historyData[i].s_total) min = this.historyData[i].s_total
          }

          if (max > 1000 || min < -1000) {
            yAxis[0].axisLabel.formatter = '{value} MVA'
            for (i = 0; i < this.historyData.length; i++) {
              chartData.a[i] = (this.historyData[i].s_pha / 1000).toFixed(2)
              chartData.b[i] = (this.historyData[i].s_phb / 1000).toFixed(2)
              chartData.c[i] = (this.historyData[i].s_phc / 1000).toFixed(2)
              chartData.t[i] = (this.historyData[i].s_total / 1000).toFixed(2)
              tableDataItem.a = (this.historyData[i].s_pha / 1000).toFixed(2) + 'MVA'
              tableDataItem.b = (this.historyData[i].s_phb / 1000).toFixed(2) + 'MVA'
              tableDataItem.c = (this.historyData[i].s_phc / 1000).toFixed(2) + 'MVA'
              tableDataItem.t = (this.historyData[i].s_total / 1000).toFixed(2) + 'MVA'
              tableData[i] = {...tableDataItem}
            }
          } else {
            yAxis[0].axisLabel.formatter = '{value} kVA'
            for (i = 0; i < this.historyData.length; i++) {
              chartData.a[i] = this.historyData[i].s_pha.toFixed(2)
              chartData.b[i] = this.historyData[i].s_phb.toFixed(2)
              chartData.c[i] = this.historyData[i].s_phc.toFixed(2)
              chartData.t[i] = this.historyData[i].s_total.toFixed(2)
              tableDataItem.a = this.historyData[i].s_pha.toFixed(2) + 'kVA'
              tableDataItem.b = this.historyData[i].s_phb.toFixed(2) + 'kVA'
              tableDataItem.c = this.historyData[i].s_phc.toFixed(2) + 'kVA'
              tableDataItem.t = this.historyData[i].s_total.toFixed(2) + 'kVA'
              tableData[i] = {...tableDataItem}
            }
          }
        } else if (this.posSelectValue === 2) {
          for (i = 0; i < this.historyData.length; i++) {
            if (max < this.historyData[i].q_pha) max = this.historyData[i].q_pha
            if (max < this.historyData[i].q_phb) max = this.historyData[i].q_phb
            if (max < this.historyData[i].q_phc) max = this.historyData[i].q_phc
            // if (max < this.historyData[i].q_total) max = this.historyData[i].q_total
            if (min > this.historyData[i].q_pha) min = this.historyData[i].q_pha
            if (min > this.historyData[i].q_phb) min = this.historyData[i].q_phb
            if (min > this.historyData[i].q_phc) min = this.historyData[i].q_phc
            // if (min > this.historyData[i].q_total) min = this.historyData[i].q_total
          }

          if (max > 1000 || min < -1000) {
            yAxis[0].axisLabel.formatter = '{value} MVar'
            for (i = 0; i < this.historyData.length; i++) {
              chartData.a[i] = (this.historyData[i].q_pha / 1000).toFixed(2)
              chartData.b[i] = (this.historyData[i].q_phb / 1000).toFixed(2)
              chartData.c[i] = (this.historyData[i].q_phc / 1000).toFixed(2)
              chartData.t[i] = (this.historyData[i].q_total / 1000).toFixed(2)
              tableDataItem.a = (this.historyData[i].q_pha / 1000).toFixed(2) + 'MVar'
              tableDataItem.b = (this.historyData[i].q_phb / 1000).toFixed(2) + 'MVar'
              tableDataItem.c = (this.historyData[i].q_phc / 1000).toFixed(2) + 'MVar'
              tableDataItem.t = (this.historyData[i].q_total / 1000).toFixed(2) + 'MVar'
              tableData[i] = {...tableDataItem}
            }
          } else {
            yAxis[0].axisLabel.formatter = '{value} kVar'
            for (i = 0; i < this.historyData.length; i++) {
              chartData.a[i] = this.historyData[i].q_pha.toFixed(2)
              chartData.b[i] = this.historyData[i].q_phb.toFixed(2)
              chartData.c[i] = this.historyData[i].q_phc.toFixed(2)
              chartData.t[i] = this.historyData[i].q_total.toFixed(2)
              tableDataItem.a = this.historyData[i].q_pha.toFixed(2) + 'kVar'
              tableDataItem.b = this.historyData[i].q_phb.toFixed(2) + 'kVar'
              tableDataItem.c = this.historyData[i].q_phc.toFixed(2) + 'kVar'
              tableDataItem.t = this.historyData[i].q_total.toFixed(2) + 'kVar'
              tableData[i] = {...tableDataItem}
            }
          }
        } else if (this.posSelectValue === 4) {
          for (i = 0; i < this.historyData.length; i++) {
            if (max < this.historyData[i].qf_pha) max = this.historyData[i].qf_pha
            if (max < this.historyData[i].qf_phb) max = this.historyData[i].qf_phb
            if (max < this.historyData[i].qf_phc) max = this.historyData[i].qf_phc
            // if (max < this.historyData[i].qf_total) max = this.historyData[i].qf_total
            if (min > this.historyData[i].qf_pha) min = this.historyData[i].qf_pha
            if (min > this.historyData[i].qf_phb) min = this.historyData[i].qf_phb
            if (min > this.historyData[i].qf_phc) min = this.historyData[i].qf_phc
            // if (min > this.historyData[i].qf_total) min = this.historyData[i].qf_total
          }

          if (max > 1000 || min < -1000) {
            yAxis[0].axisLabel.formatter = '{value} MVar'
            for (i = 0; i < this.historyData.length; i++) {
              chartData.a[i] = (this.historyData[i].qf_pha / 1000).toFixed(2)
              chartData.b[i] = (this.historyData[i].qf_phb / 1000).toFixed(2)
              chartData.c[i] = (this.historyData[i].qf_phc / 1000).toFixed(2)
              chartData.t[i] = (this.historyData[i].qf_total / 1000).toFixed(2)
              tableDataItem.a = (this.historyData[i].qf_pha / 1000).toFixed(2) + 'MVar'
              tableDataItem.b = (this.historyData[i].qf_phb / 1000).toFixed(2) + 'MVar'
              tableDataItem.c = (this.historyData[i].qf_phc / 1000).toFixed(2) + 'MVar'
              tableDataItem.t = (this.historyData[i].qf_total / 1000).toFixed(2) + 'MVar'
              tableData[i] = {...tableDataItem}
            }
          } else {
            yAxis[0].axisLabel.formatter = '{value} kVar'
            for (i = 0; i < this.historyData.length; i++) {
              chartData.a[i] = this.historyData[i].qf_pha.toFixed(2)
              chartData.b[i] = this.historyData[i].qf_phb.toFixed(2)
              chartData.c[i] = this.historyData[i].qf_phc.toFixed(2)
              chartData.t[i] = this.historyData[i].qf_total.toFixed(2)
              tableDataItem.a = this.historyData[i].qf_pha.toFixed(2) + 'kVar'
              tableDataItem.b = this.historyData[i].qf_phb.toFixed(2) + 'kVar'
              tableDataItem.c = this.historyData[i].qf_phc.toFixed(2) + 'kVar'
              tableDataItem.t = this.historyData[i].qf_total.toFixed(2) + 'kVar'
              tableData[i] = {...tableDataItem}
            }
          }
        } else if (this.posSelectValue === 5) {
          for (i = 0; i < this.historyData.length; i++) {
            if (max < this.historyData[i].qh_pha) max = this.historyData[i].qh_pha
            if (max < this.historyData[i].qh_phb) max = this.historyData[i].qh_phb
            if (max < this.historyData[i].qh_phc) max = this.historyData[i].qh_phc
            // if (max < this.historyData[i].qh_total) max = this.historyData[i].qh_total
            if (min > this.historyData[i].qh_pha) min = this.historyData[i].qh_pha
            if (min > this.historyData[i].qh_phb) min = this.historyData[i].qh_phb
            if (min > this.historyData[i].qh_phc) min = this.historyData[i].qh_phc
            // if (min > this.historyData[i].qh_total) min = this.historyData[i].qh_total
          }

          if (max > 1000 || min < -1000) {
            yAxis[0].axisLabel.formatter = '{value} MVar'
            for (i = 0; i < this.historyData.length; i++) {
              chartData.a[i] = (this.historyData[i].qh_pha / 1000).toFixed(2)
              chartData.b[i] = (this.historyData[i].qh_phb / 1000).toFixed(2)
              chartData.c[i] = (this.historyData[i].qh_phc / 1000).toFixed(2)
              chartData.t[i] = (this.historyData[i].qh_total / 1000).toFixed(2)
              tableDataItem.a = (this.historyData[i].qh_pha / 1000).toFixed(2) + 'MVar'
              tableDataItem.b = (this.historyData[i].qh_phb / 1000).toFixed(2) + 'MVar'
              tableDataItem.c = (this.historyData[i].qh_phc / 1000).toFixed(2) + 'MVar'
              tableDataItem.t = (this.historyData[i].qh_total / 1000).toFixed(2) + 'MVar'
              tableData[i] = {...tableDataItem}
            }
          } else {
            yAxis[0].axisLabel.formatter = '{value} kVar'
            for (i = 0; i < this.historyData.length; i++) {
              chartData.a[i] = this.historyData[i].qh_pha.toFixed(2)
              chartData.b[i] = this.historyData[i].qh_phb.toFixed(2)
              chartData.c[i] = this.historyData[i].qh_phc.toFixed(2)
              chartData.t[i] = this.historyData[i].qh_total.toFixed(2)
              tableDataItem.a = this.historyData[i].qh_pha.toFixed(2) + 'kVar'
              tableDataItem.b = this.historyData[i].qh_phb.toFixed(2) + 'kVar'
              tableDataItem.c = this.historyData[i].qh_phc.toFixed(2) + 'kVar'
              tableDataItem.t = this.historyData[i].qh_total.toFixed(2) + 'kVar'
              tableData[i] = {...tableDataItem}
            }
          }
        }
        option[3] = {
          name: '总',
          type: 'line',
          symbolSize: 0,
          itemStyle: {
            color: '#04404d'
          },
          data: chartData.t.reverse()
        }
      } else if (page === 2) {
        yAxis[0].axisLabel.formatter = '{value}'
        if (this.posSelectValue === 1) {
          for (i = 0; i < this.historyData.length; i++) {
            chartData.a[i] = this.historyData[i].pf_pha.toFixed(2)
            chartData.b[i] = this.historyData[i].pf_phb.toFixed(2)
            chartData.c[i] = this.historyData[i].pf_phc.toFixed(2)
            chartData.t[i] = this.historyData[i].pf_total.toFixed(2)
            tableDataItem.a = this.historyData[i].pf_pha.toFixed(2)
            tableDataItem.b = this.historyData[i].pf_phb.toFixed(2)
            tableDataItem.c = this.historyData[i].pf_phc.toFixed(2)
            tableDataItem.t = this.historyData[i].pf_total.toFixed(2)
            tableData[i] = {...tableDataItem}
          }
        } else if (this.posSelectValue === 2) {
          for (i = 0; i < this.historyData.length; i++) {
            chartData.a[i] = this.historyData[i].dpf_pha.toFixed(2)
            chartData.b[i] = this.historyData[i].dpf_phb.toFixed(2)
            chartData.c[i] = this.historyData[i].dpf_phc.toFixed(2)
            chartData.t[i] = this.historyData[i].dpf_total.toFixed(2)
            tableDataItem.a = this.historyData[i].dpf_pha.toFixed(2)
            tableDataItem.b = this.historyData[i].dpf_phb.toFixed(2)
            tableDataItem.c = this.historyData[i].dpf_phc.toFixed(2)
            tableDataItem.t = this.historyData[i].dpf_total.toFixed(2)
            tableData[i] = {...tableDataItem}
          }
        }

        option[3] = {
          name: 'AVE',
          type: 'line',
          symbolSize: 0,
          itemStyle: {
            color: '#04404d'
          },
          data: chartData.t.reverse()
        }
      } else if (page === 3 || page === 4) {
        if (page === 3) {
          if (this.posSelectValue === 3) {
            if (this.rSelectValue === 1) {
              for (i = 0; i < this.historyData.length; i++) {
                if (max < this.historyData[i].ia_rms) max = this.historyData[i].ia_rms
                if (max < this.historyData[i].ib_rms) max = this.historyData[i].ib_rms
                if (max < this.historyData[i].ic_rms) max = this.historyData[i].ic_rms
                if (max < this.historyData[i].in_rms) max = this.historyData[i].in_rms
              }
              if (max > 1000) {
                yAxis[0].axisLabel.formatter = '{value} kA'
                for (i = 0; i < this.historyData.length; i++) {
                  chartData.a[i] = (this.historyData[i].ia_rms / 1000).toFixed(2)
                  chartData.b[i] = (this.historyData[i].ib_rms / 1000).toFixed(2)
                  chartData.c[i] = (this.historyData[i].ic_rms / 1000).toFixed(2)
                  chartData.t[i] = (this.historyData[i].in_rms / 1000).toFixed(2)
                  tableDataItem.a = (this.historyData[i].ia_rms / 1000).toFixed(2) + 'kA'
                  tableDataItem.b = (this.historyData[i].ib_rms / 1000).toFixed(2) + 'kA'
                  tableDataItem.c = (this.historyData[i].ic_rms / 1000).toFixed(2) + 'kA'
                  tableDataItem.t = (this.historyData[i].in_rms / 1000).toFixed(2) + 'kA'
                  tableData[i] = {...tableDataItem}
                }
              } else {
                yAxis[0].axisLabel.formatter = '{value} A'
                for (i = 0; i < this.historyData.length; i++) {
                  chartData.a[i] = this.historyData[i].ia_rms.toFixed(2)
                  chartData.b[i] = this.historyData[i].ib_rms.toFixed(2)
                  chartData.c[i] = this.historyData[i].ic_rms.toFixed(2)
                  chartData.t[i] = this.historyData[i].in_rms.toFixed(2)
                  tableDataItem.a = this.historyData[i].ia_rms.toFixed(2) + 'A'
                  tableDataItem.b = this.historyData[i].ib_rms.toFixed(2) + 'A'
                  tableDataItem.c = this.historyData[i].ic_rms.toFixed(2) + 'A'
                  tableDataItem.t = this.historyData[i].in_rms.toFixed(2) + 'A'
                  tableData[i] = {...tableDataItem}
                }
              }
            } else if (this.rSelectValue === 2) {
              for (i = 0; i < this.historyData.length; i++) {
                if (max < this.historyData[i].ia_rms_fund) max = this.historyData[i].ia_rms_fund
                if (max < this.historyData[i].ib_rms_fund) max = this.historyData[i].ib_rms_fund
                if (max < this.historyData[i].ic_rms_fund) max = this.historyData[i].ic_rms_fund
                if (max < this.historyData[i].in_rms_fund) max = this.historyData[i].in_rms_fund
              }
              if (max > 1000) {
                yAxis[0].axisLabel.formatter = '{value} kA'
                for (i = 0; i < this.historyData.length; i++) {
                  chartData.a[i] = (this.historyData[i].ia_rms_fund / 1000).toFixed(2)
                  chartData.b[i] = (this.historyData[i].ib_rms_fund / 1000).toFixed(2)
                  chartData.c[i] = (this.historyData[i].ic_rms_fund / 1000).toFixed(2)
                  chartData.t[i] = (this.historyData[i].in_rms_fund / 1000).toFixed(2)
                  tableDataItem.a = (this.historyData[i].ia_rms_fund / 1000).toFixed(2) + 'kA'
                  tableDataItem.b = (this.historyData[i].ib_rms_fund / 1000).toFixed(2) + 'kA'
                  tableDataItem.c = (this.historyData[i].ic_rms_fund / 1000).toFixed(2) + 'kA'
                  tableDataItem.t = (this.historyData[i].in_rms_fund / 1000).toFixed(2) + 'kA'
                  tableData[i] = {...tableDataItem}
                }
              } else {
                yAxis[0].axisLabel.formatter = '{value} A'
                for (i = 0; i < this.historyData.length; i++) {
                  chartData.a[i] = this.historyData[i].ia_rms_fund.toFixed(2)
                  chartData.b[i] = this.historyData[i].ib_rms_fund.toFixed(2)
                  chartData.c[i] = this.historyData[i].ic_rms_fund.toFixed(2)
                  chartData.t[i] = this.historyData[i].in_rms_fund.toFixed(2)
                  tableDataItem.a = this.historyData[i].ia_rms_fund.toFixed(2) + 'A'
                  tableDataItem.b = this.historyData[i].ib_rms_fund.toFixed(2) + 'A'
                  tableDataItem.c = this.historyData[i].ic_rms_fund.toFixed(2) + 'A'
                  tableDataItem.t = this.historyData[i].in_rms_fund.toFixed(2) + 'A'
                  tableData[i] = {...tableDataItem}
                }
              }
            }
          } else if (this.posSelectValue === 1) {
            if (this.rSelectValue === 1) {
              for (i = 0; i < this.historyData.length; i++) {
                if (max < this.historyData[i].ua_rms) max = this.historyData[i].ua_rms
                if (max < this.historyData[i].ub_rms) max = this.historyData[i].ub_rms
                if (max < this.historyData[i].uc_rms) max = this.historyData[i].uc_rms
              }
              if (max > 1000) {
                yAxis[0].axisLabel.formatter = '{value} kV'
                for (i = 0; i < this.historyData.length; i++) {
                  chartData.a[i] = (this.historyData[i].ua_rms / 1000).toFixed(2)
                  chartData.b[i] = (this.historyData[i].ub_rms / 1000).toFixed(2)
                  chartData.c[i] = (this.historyData[i].uc_rms / 1000).toFixed(2)
                  tableDataItem.a = (this.historyData[i].ua_rms / 1000).toFixed(2) + 'kV'
                  tableDataItem.b = (this.historyData[i].ub_rms / 1000).toFixed(2) + 'kV'
                  tableDataItem.c = (this.historyData[i].uc_rms / 1000).toFixed(2) + 'kV'
                  tableData[i] = {...tableDataItem}
                }
              } else {
                yAxis[0].axisLabel.formatter = '{value} V'
                for (i = 0; i < this.historyData.length; i++) {
                  chartData.a[i] = this.historyData[i].ua_rms.toFixed(2)
                  chartData.b[i] = this.historyData[i].ub_rms.toFixed(2)
                  chartData.c[i] = this.historyData[i].uc_rms.toFixed(2)
                  tableDataItem.a = this.historyData[i].ua_rms.toFixed(2) + 'V'
                  tableDataItem.b = this.historyData[i].ub_rms.toFixed(2) + 'V'
                  tableDataItem.c = this.historyData[i].uc_rms.toFixed(2) + 'V'
                  tableData[i] = {...tableDataItem}
                }
              }
            } else if (this.rSelectValue === 2) {
              for (i = 0; i < this.historyData.length; i++) {
                if (max < this.historyData[i].ua_rms_fund) max = this.historyData[i].ua_rms_fund
                if (max < this.historyData[i].ub_rms_fund) max = this.historyData[i].ub_rms_fund
                if (max < this.historyData[i].uc_rms_fund) max = this.historyData[i].uc_rms_fund
              }
              if (max > 1000) {
                yAxis[0].axisLabel.formatter = '{value} kV'
                for (i = 0; i < this.historyData.length; i++) {
                  chartData.a[i] = (this.historyData[i].ua_rms_fund / 1000).toFixed(2)
                  chartData.b[i] = (this.historyData[i].ub_rms_fund / 1000).toFixed(2)
                  chartData.c[i] = (this.historyData[i].uc_rms_fund / 1000).toFixed(2)
                  tableDataItem.a = (this.historyData[i].ua_rms_fund / 1000).toFixed(2) + 'kV'
                  tableDataItem.b = (this.historyData[i].ub_rms_fund / 1000).toFixed(2) + 'kV'
                  tableDataItem.c = (this.historyData[i].uc_rms_fund / 1000).toFixed(2) + 'kV'
                  tableData[i] = {...tableDataItem}
                }
              } else {
                yAxis[0].axisLabel.formatter = '{value} V'
                for (i = 0; i < this.historyData.length; i++) {
                  chartData.a[i] = this.historyData[i].ua_rms_fund.toFixed(2)
                  chartData.b[i] = this.historyData[i].ub_rms_fund.toFixed(2)
                  chartData.c[i] = this.historyData[i].uc_rms_fund.toFixed(2)
                  tableDataItem.a = this.historyData[i].ua_rms_fund.toFixed(2) + 'V'
                  tableDataItem.b = this.historyData[i].ub_rms_fund.toFixed(2) + 'V'
                  tableDataItem.c = this.historyData[i].uc_rms_fund.toFixed(2) + 'V'
                  tableData[i] = {...tableDataItem}
                }
              }
            }
          } else if (this.posSelectValue === 2) {
            if (this.rSelectValue === 1) {
              for (i = 0; i < this.historyData.length; i++) {
                if (max < this.historyData[i].uab_rms) max = this.historyData[i].uab_rms
                if (max < this.historyData[i].ubc_rms) max = this.historyData[i].ubc_rms
                if (max < this.historyData[i].uca_rms) max = this.historyData[i].uca_rms
              }
              if (max > 1000) {
                yAxis[0].axisLabel.formatter = '{value} kV'
                for (i = 0; i < this.historyData.length; i++) {
                  chartData.a[i] = (this.historyData[i].uab_rms / 1000).toFixed(2)
                  chartData.b[i] = (this.historyData[i].ubc_rms / 1000).toFixed(2)
                  chartData.c[i] = (this.historyData[i].uca_rms / 1000).toFixed(2)
                  tableDataItem.a = (this.historyData[i].uab_rms / 1000).toFixed(2) + 'kV'
                  tableDataItem.b = (this.historyData[i].ubc_rms / 1000).toFixed(2) + 'kV'
                  tableDataItem.c = (this.historyData[i].uca_rms / 1000).toFixed(2) + 'kV'
                  tableData[i] = {...tableDataItem}
                }
              } else {
                yAxis[0].axisLabel.formatter = '{value} V'
                for (i = 0; i < this.historyData.length; i++) {
                  chartData.a[i] = this.historyData[i].uab_rms.toFixed(2)
                  chartData.b[i] = this.historyData[i].ubc_rms.toFixed(2)
                  chartData.c[i] = this.historyData[i].uca_rms.toFixed(2)
                  tableDataItem.a = this.historyData[i].uab_rms.toFixed(2) + 'V'
                  tableDataItem.b = this.historyData[i].ubc_rms.toFixed(2) + 'V'
                  tableDataItem.c = this.historyData[i].uca_rms.toFixed(2) + 'V'
                  tableData[i] = {...tableDataItem}
                }
              }
            } else if (this.rSelectValue === 2) {
              for (i = 0; i < this.historyData.length; i++) {
                if (max < this.historyData[i].uab_rms_fund) max = this.historyData[i].uab_rms_fund
                if (max < this.historyData[i].ubc_rms_fund) max = this.historyData[i].ubc_rms_fund
                if (max < this.historyData[i].uca_rms_fund) max = this.historyData[i].uca_rms_fund
              }
              if (max > 1000) {
                yAxis[0].axisLabel.formatter = '{value} kV'
                for (i = 0; i < this.historyData.length; i++) {
                  chartData.a[i] = (this.historyData[i].uab_rms_fund / 1000).toFixed(2)
                  chartData.b[i] = (this.historyData[i].ubc_rms_fund / 1000).toFixed(2)
                  chartData.c[i] = (this.historyData[i].uca_rms_fund / 1000).toFixed(2)
                  tableDataItem.a = (this.historyData[i].uab_rms_fund / 1000).toFixed(2) + 'kV'
                  tableDataItem.b = (this.historyData[i].ubc_rms_fund / 1000).toFixed(2) + 'kV'
                  tableDataItem.c = (this.historyData[i].uca_rms_fund / 1000).toFixed(2) + 'kV'
                  tableData[i] = {...tableDataItem}
                }
              } else {
                yAxis[0].axisLabel.formatter = '{value} V'
                for (i = 0; i < this.historyData.length; i++) {
                  chartData.a[i] = this.historyData[i].uab_rms_fund.toFixed(2)
                  chartData.b[i] = this.historyData[i].ubc_rms_fund.toFixed(2)
                  chartData.c[i] = this.historyData[i].uca_rms_fund.toFixed(2)
                  tableDataItem.a = this.historyData[i].uab_rms_fund.toFixed(2) + 'V'
                  tableDataItem.b = this.historyData[i].ubc_rms_fund.toFixed(2) + 'V'
                  tableDataItem.c = this.historyData[i].uca_rms_fund.toFixed(2) + 'V'
                  tableData[i] = {...tableDataItem}
                }
              }
            }
          }
        } else {
          yAxis[0].axisLabel.formatter = '{value} %'
          if (this.posSelectValue === 1) {
            if (this.rSelectValue === 1) {
              for (i = 0; i < this.historyData.length; i++) {
                chartData.a[i] = this.historyData[i].thd_ua_f.toFixed(2)
                chartData.b[i] = this.historyData[i].thd_ub_f.toFixed(2)
                chartData.c[i] = this.historyData[i].thd_uc_f.toFixed(2)
                tableDataItem.a = this.historyData[i].thd_ua_f.toFixed(2) + '%'
                tableDataItem.b = this.historyData[i].thd_ub_f.toFixed(2) + '%'
                tableDataItem.c = this.historyData[i].thd_uc_f.toFixed(2) + '%'
                tableData[i] = {...tableDataItem}
              }
            } else if (this.rSelectValue === 2) {
              for (i = 0; i < this.historyData.length; i++) {
                chartData.a[i] = this.historyData[i].thd_ua_r.toFixed(2)
                chartData.b[i] = this.historyData[i].thd_ub_r.toFixed(2)
                chartData.c[i] = this.historyData[i].thd_uc_r.toFixed(2)
                tableDataItem.a = this.historyData[i].thd_ua_r.toFixed(2) + '%'
                tableDataItem.b = this.historyData[i].thd_ub_r.toFixed(2) + '%'
                tableDataItem.c = this.historyData[i].thd_uc_r.toFixed(2) + '%'
                tableData[i] = {...tableDataItem}
              }
            }
          } else if (this.posSelectValue === 2) {
            if (this.rSelectValue === 1) {
              for (i = 0; i < this.historyData.length; i++) {
                chartData.a[i] = this.historyData[i].thd_uab_f.toFixed(2)
                chartData.b[i] = this.historyData[i].thd_ubc_f.toFixed(2)
                chartData.c[i] = this.historyData[i].thd_uca_f.toFixed(2)
                tableDataItem.a = this.historyData[i].thd_uab_f.toFixed(2) + '%'
                tableDataItem.b = this.historyData[i].thd_ubc_f.toFixed(2) + '%'
                tableDataItem.c = this.historyData[i].thd_uca_f.toFixed(2) + '%'
                tableData[i] = {...tableDataItem}
              }
            } else if (this.rSelectValue === 2) {
              for (i = 0; i < this.historyData.length; i++) {
                chartData.a[i] = this.historyData[i].thd_uab_r.toFixed(2)
                chartData.b[i] = this.historyData[i].thd_ubc_r.toFixed(2)
                chartData.c[i] = this.historyData[i].thd_uca_r.toFixed(2)
                tableDataItem.a = this.historyData[i].thd_uab_r.toFixed(2) + '%'
                tableDataItem.b = this.historyData[i].thd_ubc_r.toFixed(2) + '%'
                tableDataItem.c = this.historyData[i].thd_uca_r.toFixed(2) + '%'
                tableData[i] = {...tableDataItem}
              }
            }
          } else if (this.posSelectValue === 3) {
            if (this.rSelectValue === 1) {
              for (i = 0; i < this.historyData.length; i++) {
                chartData.a[i] = this.historyData[i].thd_ia_f.toFixed(2)
                chartData.b[i] = this.historyData[i].thd_ib_f.toFixed(2)
                chartData.c[i] = this.historyData[i].thd_ic_f.toFixed(2)
                chartData.t[i] = this.historyData[i].thd_in_f.toFixed(2)
                tableDataItem.a = this.historyData[i].thd_ia_f.toFixed(2) + '%'
                tableDataItem.b = this.historyData[i].thd_ib_f.toFixed(2) + '%'
                tableDataItem.c = this.historyData[i].thd_ic_f.toFixed(2) + '%'
                tableDataItem.t = this.historyData[i].thd_in_f.toFixed(2) + '%'
                tableData[i] = {...tableDataItem}
              }
            } else if (this.rSelectValue === 2) {
              for (i = 0; i < this.historyData.length; i++) {
                chartData.a[i] = this.historyData[i].thd_ia_r.toFixed(2)
                chartData.b[i] = this.historyData[i].thd_ib_r.toFixed(2)
                chartData.c[i] = this.historyData[i].thd_ic_r.toFixed(2)
                chartData.t[i] = this.historyData[i].thd_in_r.toFixed(2)
                tableDataItem.a = this.historyData[i].thd_ia_r.toFixed(2) + '%'
                tableDataItem.b = this.historyData[i].thd_ib_r.toFixed(2) + '%'
                tableDataItem.c = this.historyData[i].thd_ic_r.toFixed(2) + '%'
                tableDataItem.t = this.historyData[i].thd_in_r.toFixed(2) + '%'
                tableData[i] = {...tableDataItem}
              }
            }
          }
        }
        if (this.posSelectValue === 3) {
          option[3] = {
            name: '零相',
            type: 'line',
            symbolSize: 0,
            itemStyle: {
              color: '#00a1f5'
            },
            data: chartData.t.reverse()
          }
        }
      } else if (page === 5) {
        if (this.posSelectValue === 1) {
          for (i = 0; i < this.historyData.length; i++) {
            if (max < this.historyData[i].uph_pos) max = this.historyData[i].uph_pos
            if (max < this.historyData[i].uph_neg) max = this.historyData[i].uph_neg
            if (max < this.historyData[i].uph_zero) max = this.historyData[i].uph_zero
          }
          if (max > 1000) {
            for (i = 0; i < this.historyData.length; i++) {
              chartData.a[i] = (this.historyData[i].uph_pos / 1000).toFixed(2)
              chartData.b[i] = (this.historyData[i].uph_neg / 1000).toFixed(2)
              chartData.c[i] = (this.historyData[i].uph_zero / 1000).toFixed(2)
              chartData.t[i] = (this.historyData[i].unbal_uph).toFixed(2)
              tableDataItem.a = (this.historyData[i].uph_pos / 1000).toFixed(2) + 'kV'
              tableDataItem.b = (this.historyData[i].uph_neg / 1000).toFixed(2) + 'kV'
              tableDataItem.c = (this.historyData[i].uph_zero / 1000).toFixed(2) + 'kV'
              tableDataItem.t = (this.historyData[i].unbal_uph).toFixed(2) + '%'
              tableData[i] = {...tableDataItem}
            }
          } else {
            for (i = 0; i < this.historyData.length; i++) {
              chartData.a[i] = this.historyData[i].uph_pos.toFixed(2)
              chartData.b[i] = this.historyData[i].uph_neg.toFixed(2)
              chartData.c[i] = this.historyData[i].uph_zero.toFixed(2)
              chartData.t[i] = this.historyData[i].unbal_uph.toFixed(2)
              tableDataItem.a = this.historyData[i].uph_pos.toFixed(2) + 'V'
              tableDataItem.b = this.historyData[i].uph_neg.toFixed(2) + 'V'
              tableDataItem.c = this.historyData[i].uph_zero.toFixed(2) + 'V'
              tableDataItem.t = this.historyData[i].unbal_uph.toFixed(2) + '%'
              tableData[i] = {...tableDataItem}
            }
          }
        } else if (this.posSelectValue === 2) {
          for (i = 0; i < this.historyData.length; i++) {
            if (max < this.historyData[i].ull_pos) max = this.historyData[i].ull_pos
            if (max < this.historyData[i].ull_neg) max = this.historyData[i].ull_neg
            if (max < this.historyData[i].ull_zero) max = this.historyData[i].ull_zero
          }
          if (max > 1000) {
            for (i = 0; i < this.historyData.length; i++) {
              chartData.a[i] = (this.historyData[i].ull_pos / 1000).toFixed(2)
              chartData.b[i] = (this.historyData[i].ull_neg / 1000).toFixed(2)
              chartData.c[i] = (this.historyData[i].ull_zero / 1000).toFixed(2)
              chartData.t[i] = (this.historyData[i].unbal_ull).toFixed(2)
              tableDataItem.a = (this.historyData[i].ull_pos / 1000).toFixed(2) + 'kV'
              tableDataItem.b = (this.historyData[i].ull_neg / 1000).toFixed(2) + 'kV'
              tableDataItem.c = (this.historyData[i].ull_zero / 1000).toFixed(2) + 'kV'
              tableDataItem.t = (this.historyData[i].unbal_ull).toFixed(2) + '%'
              tableData[i] = {...tableDataItem}
            }
          } else {
            for (i = 0; i < this.historyData.length; i++) {
              chartData.a[i] = this.historyData[i].ull_pos.toFixed(2)
              chartData.b[i] = this.historyData[i].ull_neg.toFixed(2)
              chartData.c[i] = this.historyData[i].ull_zero.toFixed(2)
              chartData.t[i] = this.historyData[i].unbal_ull.toFixed(2)
              tableDataItem.a = this.historyData[i].ull_pos.toFixed(2) + 'V'
              tableDataItem.b = this.historyData[i].ull_neg.toFixed(2) + 'V'
              tableDataItem.c = this.historyData[i].ull_zero.toFixed(2) + 'V'
              tableDataItem.t = this.historyData[i].unbal_ull.toFixed(2) + '%'
              tableData[i] = {...tableDataItem}
            }
          }
        } else if (this.posSelectValue === 3) {
          for (i = 0; i < this.historyData.length; i++) {
            if (max < this.historyData[i].i_pos) max = this.historyData[i].i_pos
            if (max < this.historyData[i].i_neg) max = this.historyData[i].i_neg
            if (max < this.historyData[i].i_zero) max = this.historyData[i].i_zero
          }
          if (max > 1000) {
            for (i = 0; i < this.historyData.length; i++) {
              chartData.a[i] = (this.historyData[i].i_pos / 1000).toFixed(2)
              chartData.b[i] = (this.historyData[i].i_neg / 1000).toFixed(2)
              chartData.c[i] = (this.historyData[i].i_zero / 1000).toFixed(2)
              chartData.t[i] = (this.historyData[i].unbal_i).toFixed(2)
              tableDataItem.a = (this.historyData[i].i_pos / 1000).toFixed(2) + 'kA'
              tableDataItem.b = (this.historyData[i].i_neg / 1000).toFixed(2) + 'kA'
              tableDataItem.c = (this.historyData[i].i_zero / 1000).toFixed(2) + 'kA'
              tableDataItem.t = (this.historyData[i].unbal_i).toFixed(2) + '%'
              tableData[i] = {...tableDataItem}
            }
          } else {
            for (i = 0; i < this.historyData.length; i++) {
              chartData.a[i] = this.historyData[i].i_pos.toFixed(2)
              chartData.b[i] = this.historyData[i].i_neg.toFixed(2)
              chartData.c[i] = this.historyData[i].i_zero.toFixed(2)
              chartData.t[i] = this.historyData[i].unbal_i.toFixed(2)
              tableDataItem.a = this.historyData[i].i_pos.toFixed(2) + 'A'
              tableDataItem.b = this.historyData[i].i_neg.toFixed(2) + 'A'
              tableDataItem.c = this.historyData[i].i_zero.toFixed(2) + 'A'
              tableDataItem.t = this.historyData[i].unbal_i.toFixed(2) + '%'
              tableData[i] = {...tableDataItem}
            }
          }
        }
        option = [{
          name: '正序分量',
          type: 'line',
          symbolSize: 0,
          yAxisIndex: 0,
          data: chartData.a,
          itemStyle: {
            color: '#04404d'
          }
        }, {
          name: '负序分量',
          type: 'line',
          symbolSize: 0,
          yAxisIndex: 1,
          data: chartData.b,
          itemStyle: {
            color: '#24804a'
          }
        }, {
          name: '不平衡度',
          type: 'line',
          symbolSize: 0,
          yAxisIndex: 2,
          data: chartData.t.reverse(),
          itemStyle: {
            color: '#c58055'
          }
        }]

        if (this.posSelectValue !== 2) {
          option.splice(2, 0, {
            name: '零序分量',
            type: 'line',
            symbolSize: 0,
            yAxisIndex: 1,
            data: chartData.c,
            itemStyle: {
              color: '#b3cb72'
            }
          })
        }

        yAxis = [{
          type: 'value',
          name: (max > 1000) ? (this.posSelectValue === 3 ? '正序分量(kA)' : '正序分量(kV)') : (this.posSelectValue === 3 ? '正序分量(A)' : '正序分量(V)')
        }, {
          type: 'value',
          name: (max > 1000) ? (this.posSelectValue === 3 ? '正序分量(kA)' : '正序分量(kV)') : (this.posSelectValue === 3 ? '正序分量(A)' : '正序分量(V)')
        }, {
          type: 'value',
          name: '不平衡度(%)',
          offset: 70
        }]
      } else if (page === 6) {
        if (this.posSelectValue === 1) {
          for (i = 0; i < this.historyData.length; i++) {
            if (max < this.historyData[i].ea_kwh) max = this.historyData[i].ea_kwh
            if (max < this.historyData[i].eb_kwh) max = this.historyData[i].eb_kwh
            if (max < this.historyData[i].ec_kwh) max = this.historyData[i].ec_kwh
            if (min > this.historyData[i].ea_kwh) min = this.historyData[i].ea_kwh
            if (min > this.historyData[i].eb_kwh) min = this.historyData[i].eb_kwh
            if (min > this.historyData[i].ec_kwh) min = this.historyData[i].ec_kwh
          }

          if (max > 1000 || min < -1000) {
            yAxis[0].axisLabel.formatter = '{value} MWh'
            for (i = 0; i < this.historyData.length; i++) {
              chartData.a[i] = (this.historyData[i].ea_kwh / 1000).toFixed(2)
              chartData.b[i] = (this.historyData[i].eb_kwh / 1000).toFixed(2)
              chartData.c[i] = (this.historyData[i].ec_kwh / 1000).toFixed(2)
              chartData.t[i] = (this.historyData[i].et_kwh / 1000).toFixed(2)
              tableDataItem.a = (this.historyData[i].ea_kwh / 1000).toFixed(2) + 'MWh'
              tableDataItem.b = (this.historyData[i].eb_kwh / 1000).toFixed(2) + 'MWh'
              tableDataItem.c = (this.historyData[i].ec_kwh / 1000).toFixed(2) + 'MWh'
              tableDataItem.t = (this.historyData[i].et_kwh / 1000).toFixed(2) + 'MWh'
              tableData[i] = {...tableDataItem}
            }
          } else {
            yAxis[0].axisLabel.formatter = '{value} kWh'
            for (i = 0; i < this.historyData.length; i++) {
              chartData.a[i] = this.historyData[i].ea_kwh
              chartData.b[i] = this.historyData[i].eb_kwh
              chartData.c[i] = this.historyData[i].ec_kwh
              chartData.t[i] = this.historyData[i].et_kwh
              tableDataItem.a = this.historyData[i].ea_kwh + 'kWh'
              tableDataItem.b = this.historyData[i].eb_kwh + 'kWh'
              tableDataItem.c = this.historyData[i].ec_kwh + 'kWh'
              tableDataItem.t = this.historyData[i].et_kwh + 'kWh'
              tableData[i] = {...tableDataItem}
            }
          }
        } else if (this.posSelectValue === 2) {
          for (i = 0; i < this.historyData.length; i++) {
            if (max < this.historyData[i].ea_kvarh) max = this.historyData[i].ea_kvarh
            if (max < this.historyData[i].eb_kvarh) max = this.historyData[i].eb_kvarh
            if (max < this.historyData[i].ec_kvarh) max = this.historyData[i].ec_kvarh
            if (min > this.historyData[i].ea_kvarh) min = this.historyData[i].ea_kvarh
            if (min > this.historyData[i].eb_kvarh) min = this.historyData[i].eb_kvarh
            if (min > this.historyData[i].ec_kvarh) min = this.historyData[i].ec_kvarh
          }

          if (max > 1000 || min < -1000) {
            yAxis[0].axisLabel.formatter = '{value} MVarh'
            for (i = 0; i < this.historyData.length; i++) {
              chartData.a[i] = (this.historyData[i].ea_kvarh / 1000).toFixed(2)
              chartData.b[i] = (this.historyData[i].eb_kvarh / 1000).toFixed(2)
              chartData.c[i] = (this.historyData[i].ec_kvarh / 1000).toFixed(2)
              chartData.t[i] = (this.historyData[i].et_kvarh / 1000).toFixed(2)
              tableDataItem.a = (this.historyData[i].ea_kvarh / 1000).toFixed(2) + 'MVarh'
              tableDataItem.b = (this.historyData[i].eb_kvarh / 1000).toFixed(2) + 'MVarh'
              tableDataItem.c = (this.historyData[i].ec_kvarh / 1000).toFixed(2) + 'MVarh'
              tableDataItem.t = (this.historyData[i].et_kvarh / 1000).toFixed(2) + 'MVarh'
              tableData[i] = {...tableDataItem}
            }
          } else {
            yAxis[0].axisLabel.formatter = '{value} kVarh'
            for (i = 0; i < this.historyData.length; i++) {
              chartData.a[i] = this.historyData[i].ea_kvarh
              chartData.b[i] = this.historyData[i].eb_kvarh
              chartData.c[i] = this.historyData[i].ec_kvarh
              chartData.t[i] = this.historyData[i].et_kvarh
              tableDataItem.a = this.historyData[i].ea_kvarh + 'kVarh'
              tableDataItem.b = this.historyData[i].eb_kvarh + 'kVarh'
              tableDataItem.c = this.historyData[i].ec_kvarh + 'kVarh'
              tableDataItem.t = this.historyData[i].et_kvarh + 'kVarh'
              tableData[i] = {...tableDataItem}
            }
          }
        } else if (this.posSelectValue === 3) {
          for (i = 0; i < this.historyData.length; i++) {
            if (max < this.historyData[i].ea_kvah) max = this.historyData[i].ea_kvah
            if (max < this.historyData[i].eb_kvah) max = this.historyData[i].eb_kvah
            if (max < this.historyData[i].ec_kvah) max = this.historyData[i].ec_kvah
            if (min > this.historyData[i].ea_kvah) min = this.historyData[i].ea_kvah
            if (min > this.historyData[i].eb_kvah) min = this.historyData[i].eb_kvah
            if (min > this.historyData[i].ec_kvah) min = this.historyData[i].ec_kvah
          }

          if (max > 1000 || min < -1000) {
            yAxis[0].axisLabel.formatter = '{value} MVAh'
            for (i = 0; i < this.historyData.length; i++) {
              chartData.a[i] = (this.historyData[i].ea_kvah / 1000).toFixed(2)
              chartData.b[i] = (this.historyData[i].eb_kvah / 1000).toFixed(2)
              chartData.c[i] = (this.historyData[i].ec_kvah / 1000).toFixed(2)
              chartData.t[i] = (this.historyData[i].et_kvah / 1000).toFixed(2)
              tableDataItem.a = (this.historyData[i].ea_kvah / 1000).toFixed(2) + 'MVAh'
              tableDataItem.b = (this.historyData[i].eb_kvah / 1000).toFixed(2) + 'MVAh'
              tableDataItem.c = (this.historyData[i].ec_kvah / 1000).toFixed(2) + 'MVAh'
              tableDataItem.t = (this.historyData[i].et_kvah / 1000).toFixed(2) + 'MVAh'
              tableData[i] = {...tableDataItem}
            }
          } else {
            yAxis[0].axisLabel.formatter = '{value} kVAh'
            for (i = 0; i < this.historyData.length; i++) {
              chartData.a[i] = this.historyData[i].ea_kvah
              chartData.b[i] = this.historyData[i].eb_kvah
              chartData.c[i] = this.historyData[i].ec_kvah
              chartData.t[i] = this.historyData[i].et_kvah
              tableDataItem.a = this.historyData[i].ea_kvah + 'kVAh'
              tableDataItem.b = this.historyData[i].eb_kvah + 'kVAh'
              tableDataItem.c = this.historyData[i].ec_kvah + 'kVAh'
              tableDataItem.t = this.historyData[i].et_kvah + 'kVAh'
              tableData[i] = {...tableDataItem}
            }
          }
        }
        option[3] = {
          name: '总',
          type: 'line',
          symbolSize: 0,
          itemStyle: {
            color: '#04404d'
          },
          data: chartData.t.reverse()
        }
      }
      for (i = 0; i < this.historyData.length; i++) {
        chartData.dt[i] = this.historyData[i].dt.slice(11, 19)
        tableData[i].dt = this.historyData[i].dt
      }
      this.tableData = tableData
      option[0].data = chartData.a.reverse()
      option[1].data = chartData.b.reverse()
      option[2].data = chartData.c.reverse()
      this.options.xAxis[0].data = chartData.dt.reverse()
      this.options.series = option
      this.options.yAxis = yAxis
      if (page !== 7) {
        if (this.chart == null) {
          this.chart = this.$echarts.init(document.getElementById('main'))
        }
        this.chart.clear()
        this.chart.setOption(this.options)
      }
    },

    async updateData (newDate) {
      let params = {
        'collection': 'meter_stable_data',
        'sn': this.$store.state.sn ? this.$store.state.sn : window.localStorage.getItem('sn'),
        'date': formatTime(newDate, 'yyyy-MM-dd'),
        'fields': []
      }
      if (this.dataType === 1) {
        if (this.posSelectValue === 1) {
          params.fields = ['p_pha', 'p_phb', 'p_phc', 'p_total']
        } else if (this.posSelectValue === 2) {
          params.fields = ['q_pha', 'q_phb', 'q_phc', 'q_total']
        } else if (this.posSelectValue === 3) {
          params.fields = ['s_pha', 's_phb', 's_phc', 's_total']
        } else if (this.posSelectValue === 4) {
          params.fields = ['qf_pha', 'qf_phb', 'qf_phc', 'qf_total']
        } else if (this.posSelectValue === 5) {
          params.fields = ['qh_pha', 'qh_phb', 'qh_phc', 'qh_total']
        }
      } else if (this.dataType === 2) {
        if (this.posSelectValue === 1) {
          params.fields = ['pf_pha', 'pf_phb', 'pf_phc', 'pf_total']
        } else if (this.posSelectValue === 2) {
          params.fields = ['dpf_pha', 'dpf_phb', 'dpf_phc', 'dpf_total']
        }
      } else if (this.dataType === 3) {
        if (this.posSelectValue === 1) {
          if (this.rSelectValue === 1) {
            params.fields = ['ua_rms', 'ub_rms', 'uc_rms']
          } else if (this.rSelectValue === 2) {
            params.fields = ['ua_rms_fund', 'ub_rms_fund', 'uc_rms_fund']
          }
        } else if (this.posSelectValue === 2) {
          if (this.rSelectValue === 1) {
            params.fields = ['uab_rms', 'ubc_rms', 'uca_rms']
          } else if (this.rSelectValue === 2) {
            params.fields = ['uab_rms_fund', 'ubc_rms_fund', 'uca_rms_fund']
          }
        } else if (this.posSelectValue === 3) {
          if (this.rSelectValue === 1) {
            params.fields = ['ia_rms', 'ib_rms', 'ic_rms', 'in_rms']
          } else if (this.rSelectValue === 2) {
            params.fields = ['ia_rms_fund', 'ib_rms_fund', 'ic_rms_fund', 'in_rms_fund']
          }
        }
      } else if (this.dataType === 4) {
        if (this.posSelectValue === 1) {
          if (this.rSelectValue === 1) {
            params.fields = ['thd_ua_f', 'thd_ub_f', 'thd_uc_f']
          } else if (this.rSelectValue === 2) {
            params.fields = ['thd_ua_r', 'thd_ub_r', 'thd_uc_r']
          }
        } else if (this.posSelectValue === 2) {
          if (this.rSelectValue === 1) {
            params.fields = ['thd_uab_f', 'thd_ubc_f', 'thd_uca_f']
          } else if (this.rSelectValue === 2) {
            params.fields = ['thd_uab_r', 'thd_ubc_r', 'thd_uca_r']
          }
        } else if (this.posSelectValue === 3) {
          if (this.rSelectValue === 1) {
            params.fields = ['thd_ia_f', 'thd_ib_f', 'thd_ic_f', 'thd_in_f']
          } else if (this.rSelectValue === 2) {
            params.fields = ['thd_ia_r', 'thd_ib_r', 'thd_ic_r', 'thd_in_r']
          }
        }
      } else if (this.dataType === 5) {
        if (this.posSelectValue === 1) {
          params.fields = ['uph_pos', 'uph_neg', 'uph_zero', 'unbal_uph']
        } else if (this.posSelectValue === 2) {
          params.fields = ['ull_pos', 'ull_neg', 'ull_zero', 'unbal_ull']
        } else if (this.posSelectValue === 3) {
          params.fields = ['i_pos', 'i_neg', 'i_zero', 'unbal_i']
        }
      } else if (this.dataType === 6) {
        if (this.posSelectValue === 1) {
          params.fields = ['ea_kwh', 'eb_kwh', 'ec_kwh', 'et_kwh']
        } else if (this.posSelectValue === 2) {
          params.fields = ['ea_kvarh', 'eb_kvarh', 'ec_kvarh', 'et_kvarh']
        } else if (this.posSelectValue === 3) {
          params.fields = ['ea_kvah', 'eb_kvah', 'ec_kvah', 'et_kvah']
        }
      }
      params.fields.push('dt')
      const {data: res} = await this.$api.queryDateData(params)
      if (res.code !== 0) {
        this.$message.error(res.msg)
      }
      this.historyData = res.data
    },

    dialogClickEventHandle (index) {
      this.dialogTableVisible = true
      this.dialogEventWaveChart = this.$echarts.init(document.getElementById('eventWaveChart'))
      this.dialogEventWaveChart.setOption(this.dialogEventWaveOption)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/History/History.vue